
import React from "react";
import { Schemes, Utils } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Elements } from "../../../../shared/Elements";
import { ConfirmDialog, Siren } from "../../../../shared/ConfirmDialog";
import { BoolHelper, Button, ButtonManageRef, Checkbox, Classname, Form, FormControl, Scheme, TextAreaInput, TextInput } from "@rivtn/noseur";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { ApiResponseData, BaseService, IHost, IMember, IProfileWebsite, IHostManager, MemberService, SanitizedResponse, TeamRole, TeamService, HostService, ConsusService, IUploadedFile, IHostWebsite } from "../../../../../services";
import MediaInput from "../../../../shared/MediaInput";

export interface CompanyInfoProps {
    host: IHost;
    profile: IMember;
    hostWebsite: IHostWebsite;
}

function CompanyInfo(props: CompanyInfoProps) {

    const { host } = props;
    const hostService = HostService.getInstance();
    const labels = i18nManager.Labels.host.settings.about.company_info;
    const [hostWebsite, setHostWebsite] = React.useState<IHostWebsite>(props.hostWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings" style={{ padding: 0, boxShadow: "none", maxWidth: 600 }}>
        <FormControl isFieldset fill label={labels.title} style={{ marginTop: 20 }}>
            <TextAreaInput fill defaultValue={hostWebsite.about_settings.info} style={{ height: 400 }} onInputComplete={(info) => {
                setHostWebsite({ ...hostWebsite, about_settings: { ...hostWebsite.about_settings, info } });
            }} />
        </FormControl>
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={i18nManager.Labels.common.save_changes}
            style={{ marginTop: 50, padding: "10px 25px", }} onClick={(e) => updateCompanyInfo(e.manageRef)} />
    </Form>);

    function updateCompanyInfo(manageRef?: ButtonManageRef) {
        manageRef?.setLoadingState(true);
        hostService.updateHostWebsite(host.external_id, hostWebsite).then(({ sanitized }: SanitizedResponse<IHostWebsite>) => {
            Siren.alert(labels.update_success);
        }).catch(BaseService.reportError).finally(() => manageRef?.setLoadingState(false));
    }

}

export default CompanyInfo;
